import _ from "underscore";

import { CreateNewIdentityComponents } from "../../../components";

import CreateNewIdentityRequest from "../../../service/request/CreateNewIdentityRequest";
import LeadPartyApi from "../../../service/LeadPartyService";
import AuthorizationApi from "../../../service/AuthorizationService";
export default {
  name: "NewIdentity",
  mixins: [],
  components: {
    ...CreateNewIdentityComponents
  },
  data() {
    return {
      GM_UNIT_CODE: "001",
      unitCode: null,
      userList: [],
      stateValues: {
        tckn: "",
        name: "",
        surname: "",
        phoneNumber: "",
        email: "",
        primaryContactType: "PHONE",
        investmentConsultant: "",
        channelInfo: "",
        channelInfoValue: "",
        selectedNfcCompatible: true,
        showIdentityCreatedDialog: false,
        showNoNfcWarningDialog: false,
        submitting: false
      },
      preferredCountries: ["tr", "us", "de", "gb", "jp", "cn"],
      errorMessages: this.$t("pleaseEnterValidPhoneNumber"),
      rules: {
        tcknRequired: v => !!v || this.$t("tcknFieldRequired"),
        tcknValidLength: v =>
          (v && v.length === 11 && /^\d+$/.test(v)) ||
          this.$t("pleaseEnterValidTCKN"),
        nameRequired: v => !!v || this.$t("nameRequired"),
        surnameRequired: v => !!v || this.$t("surnameRequired"),
        phoneNumberRequired: v => !!v || this.$t("phoneNumberFieldRequired"),
        phoneNumberValid: v =>
          /\d{4}\s\d{3}\s\d{2}\s\d{2}$/.test(v) ||
          this.$t("pleaseEnterValidPhoneNumber"),
        emailRequired: v => !!v || this.$t("emailFieldRequired"),
        emailValid: v =>
          /.+@.+\..+/.test(v) || this.$t("pleaseEnterValidEmail"),
        emailValidLength: v => {
          if (v) {
            const groups = /(.+)@(.+)\.(.+)/g.exec(v.trim());
            return (
              (groups &&
                groups[1].length <= 64 &&
                groups[2].length + groups[3].length <= 255) ||
              this.$t("invalidEmailLength")
            );
          } else {
            return false;
          }
        },
        investmentConsultantFieldRequired: consultant => !!consultant || this.$t("investmentConsultantFieldRequired")
      }
    };
  },
  computed: {
    isBranchUser: function() {
      return this.$store.getters["user"].unitCode != this.GM_UNIT_CODE;
    },
    /*
    primaryContactTypeItems: function() {
      return [
        {
          value: "PHONE",
          text: this.$t("phone").toUpperCase()
        },
        {
          value: "EMAIL",
          text: this.$t("email").toUpperCase()
        }
      ];
    },
    */
    nfcCompatibleItems: function() {
      return [
        {
          value: true,
          text: this.$t("available").toUpperCase()
        },
        {
          value: false,
          text: this.$t("notAvailable").toUpperCase()
        }
      ];
    },
    unitCodeItems: function() {
      let vm = this;
      let pair = [];
      for (const user of this.userList) {
        if (
          user.unitCode != null &&
          !pair.some(x => x.unitCode === user.unitCode)
        ) {
          pair.push({
            unitType: user.unitType,
            unitCode: user.unitCode
          });
        }
      }
      pair.sort(function(a, b) {
        if (b.unitCode == vm.GM_UNIT_CODE) {
          return 1;
        } else if (a.unitCode == vm.GM_UNIT_CODE) {
          return -1;
        } else {
          return a.unitType.localeCompare(b.unitType);
        }
      });
      return pair;
    },
    consultantItems: function() {
      let items = [];
      for (const user of this.userList) {
        if (this.unitCode != null && this.unitCode == user.unitCode && user.status == "ACTIVE") {
          items.push({
            text: user.fullName,
            value: user.fullName
          });
        }
      }
      return items.sort(function(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });
    }
  },
  beforeMount: async function() {
    this.userList = await this.getUsers();
    this.unitCode = this.defaultUnitCode();
  },
  methods: {
    onSelectedNfcCompatibleChange(value) {
      if (!value) {
        this.stateValues.showNoNfcWarningDialog = true;
      }
    },
    onNoNfcWarningDialogClosed() {
      this.stateValues.showNoNfcWarningDialog = false;
    },
    async onTcknFieldFilled() {
      if (this.isTCKNValid(this.stateValues.tckn)) {
        const isTcknValidated = await this.validateTckn(this.stateValues.tckn);
        if (isTcknValidated) {
          this.stateValues.channelInfo = channelInfo.label;
          this.stateValues.channelInfoValue = channelInfo.value;
        } else {
          this.stateValues.channelInfo = "";
          this.stateValues.channelInfoValue = "";
          this.$eventHub.$emit("error-happened", {
            title: "warning",
            id: "",
            warningMessage: this.$t("pleaseEnterValidTCKN")
          });
        }
      } else {
        this.stateValues.channelInfo = "";
        this.stateValues.channelInfoValue = "";
      }
    },
    onEmailFieldFilled() {
      this.stateValues.email = this.stateValues.email.trim();
    },
    async submit() {   
      const isValid = this.$refs.form.validate();
      if (!this.stateValues.submitting && isValid) {
        this.stateValues.submitting = true;
        const isTcknValidated = await this.validateTckn(this.stateValues.tckn);
        if (isTcknValidated) {     
          const createdLeadPartyResponse = await this.createLeadParty(
            this.stateValues.tckn,
            this.stateValues.name,
            this.stateValues.surname,
            this.stateValues.phoneNumber,
            this.stateValues.email.trim(),
            this.stateValues.addressCode,
            this.stateValues.primaryContactType,
            this.stateValues.investmentConsultant,
            this.stateValues.channelInfoValue
            // ,this.stateValues.selectedNfcCompatible
          );

          if (createdLeadPartyResponse) {
            this.clearForm();
            this.stateValues.showIdentityCreatedDialog = true;
          }
        } else {
          this.$eventHub.$emit("error-happened", {
            title: "warning",
            id: "",
            warningMessage: this.$t("pleaseEnterValidTCKN")
          });
        }
        this.stateValues.submitting = false;
      }else{
        this.stateValues.submitting = false;
      }
    },
    isTCKNValid(tckn) {
      return tckn && tckn.length === 11 && /^\d+$/.test(tckn);
    },
    validateTckn(tckn) {
      return new Promise(resolve => {
        LeadPartyApi.checkTckn(
          this,
          tckn,
          response => {
            if (response && response.result) {
              resolve(response.result);
            } else {
              resolve(false);
            }
          },
          error => {
            console.log(error, "checkTckn error");
            resolve(false);
          }
        );
      });
    },
    async createLeadParty(
      tckn,
      name,
      surname,
      phoneNumber,
      email,
      addressCode,
      primaryContactType,
      investmentConsultant,
      channel
      //,hasNFCPhone
    ) {
      return new Promise(resolve => {
        const createNewIdentityRequest = new CreateNewIdentityRequest();
        let areaCodeIndex = phoneNumber.indexOf(" ");
        createNewIdentityRequest.leadPartyDTO = {
          tckn: tckn,
          name: name,
          surname: surname,
          phoneCountryCode: phoneNumber.substr(0, areaCodeIndex),
          phone: phoneNumber
            .substr(areaCodeIndex, phoneNumber.length)
            .replace(/\s/g, "")
            .replace(/-/g, ""),
          email: email,
          addressCode: addressCode,
          primaryContactType: primaryContactType,
          channel: channel ? channel : null,
          hasNFCPhone:true, //hasNFCPhone,
          assigneeId:
            investmentConsultant !== ""
              ? this.userList.find(x => x.fullName == investmentConsultant).id
              : null,
          domainId:
            investmentConsultant !== ""
              ? this.userList.find(x => x.fullName == investmentConsultant)
                  .domainId
              : null
        };

        LeadPartyApi.createLeadParty(
          this,
          createNewIdentityRequest,
          response => {
            if (response && response.success) {
              resolve(true);
            }
            resolve(false);
          },
          error => {
            console.log(error);
            resolve(false);
          }
        );
      });
    },
    createAnotherIdentity() {
      this.stateValues.showIdentityCreatedDialog = false;
    },
    clearForm() {
      this.$refs.form.resetValidation();
      this.unitCode = this.defaultUnitCode();
      this.stateValues.tckn = "";
      this.stateValues.name = "";
      this.stateValues.phoneNumber = "";
      this.stateValues.email = "";
      this.stateValues.addressCode = "";
      this.stateValues.primaryContactType = "PHONE";
      this.stateValues.investmentConsultant = "";
      //this.stateValues.selectedNfcCompatible = true;
      this.stateValues.surname = "";
      this.stateValues.channelInfo = "";
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-ZığüşöçİĞÜŞÖÇ\s]+$/.test(char)) {
        return true;
      } else {
        e.preventDefault();
      }
    },
    isNumeric(e) {
      let numeric = String.fromCharCode(e.keyCode);
      if (/^\d+$/.test(numeric)) {
        return true;
      } else {
        e.preventDefault();
      }
    },
    getUsers: function() {
      return new Promise(resolve => {
        AuthorizationApi.getUsers(
          this,
          response => {
            if (response != null && response.resultList != null) {
              resolve(
                response.resultList.filter(
                  user => user.domainId == this.$store.getters["user"].domainId
                )
              );
            }
            resolve([]);
          },
          error => {
            resolve([]);
          }
        );
      });
    },
    defaultUnitCode: function() {
      if (this.$store.getters["user"].unitCode != this.GM_UNIT_CODE) {
        return this.$store.getters["user"].unitCode;
      }
      return null;
    },
    onPasteEmail(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      this.stateValues.email = pastedText.trim();
      event.preventDefault();
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/createnewidentity/mixin/CreateNewIdentity.js